// import React, { FormEvent, useState } from "react";
// import { useNavigate, useLocation, Link } from "react-router-dom";
// import { useLoginMutation } from "../api/authApi";
// import { getDefaultRouteForUser } from "../utils/redirect";

// const STORAGE_KEY = "logbook_auth_user_v2";

// const LoginPage: React.FC = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [login, { isLoading, error }] = useLoginMutation();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const [localError, setLocalError] = useState<string | null>(null);
//   const from = (location.state as any)?.from?.pathname;

//   const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     setLocalError(null);

//     localStorage.removeItem("token");
//     localStorage.removeItem(STORAGE_KEY);

//     try {
//       const res = await login({ email, password }).unwrap();

//       if (!res?.token || !res?.user) {
//         setLocalError(res?.message || "Invalid email or password");
//         return;
//       }

//       // ✅ keep your function call consistent (no args)
//       navigate(from || getDefaultRouteForUser(), { replace: true });
//     } catch (err: any) {
//       setLocalError(
//         err?.data?.message || err?.message || "Login failed. Try again."
//       );
//     }
//   };

//   /**
//    * ERROR LOGIC
//    * - show localError first (covers backend 200 failures)
//    * - otherwise use RTK Query's error object
//    */
//   const getErrorMessage = () => {
//     if (localError) return localError;

//     if (!error) return null;

//     if ("status" in error) {
//       if (typeof error.status === "number") {
//         if (error.status === 401) return "Invalid email or password";
//         if (error.status === 404) return "Login endpoint not found (404)";
//         if (error.status === 500) return "Server error (500)";
//         return `Server Error: ${error.status}`;
//       }

//       switch (error.status) {
//         case "FETCH_ERROR":
//           return "Network error: Cannot reach the server.";
//         case "TIMEOUT_ERROR":
//           return "Request timed out. Please try again.";
//         default:
//           return "A connection error occurred.";
//       }
//     }

//     if ("message" in error) {
//       return (
//         (error as any)?.data?.message ||
//         (error as any)?.message ||
//         "An unexpected error occurred"
//       );
//     }

//     return "Login failed";
//   };

//   const errorMessage = getErrorMessage();

//   return (
//     <div className="fixed inset-0 h-screen w-screen flex overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-slate-900">
//       {/* LEFT SIDE */}
//       <div className="hidden lg:flex flex-1 items-center justify-center p-10 border-r border-white/5">
//         <div className="max-w-md text-slate-100">
//           <div className="flex items-center gap-3 mb-6">
//             <div className="h-10 w-10 rounded-xl bg-indigo-500/20 flex items-center justify-center border border-indigo-400/40">
//               <span className="text-lg font-bold text-indigo-300">ADM</span>
//             </div>
//             <div>
//               <div className="text-xs uppercase tracking-widest text-slate-400">
//                 NIQS PORTAL
//               </div>
//               <div className="text-base font-semibold text-slate-100">
//                 Login
//               </div>
//             </div>
//           </div>
//           <div className="space-y-2">
//             <h1 className="text-2xl font-semibold">Membership Portal</h1>
//             <p className="text-sm text-slate-300">
//               Sign in with your credentials.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* RIGHT SIDE */}
//       <div className="flex-1 flex items-center justify-center px-4 py-10 lg:px-8">
//         <div className="w-full max-w-md">
//           <div className="bg-white/95 backdrop-blur rounded-2xl shadow-xl border border-slate-100 px-6 py-8 sm:px-8 sm:py-10">
//             <div className="mb-6 text-center">
//               <h2 className="text-xl font-semibold text-slate-900">
//                 NIQS PORTAL
//               </h2>
//               <p className="mt-1 text-xs text-slate-500">
//                 Enter your credentials to access the console.
//               </p>
//             </div>

//             <form onSubmit={onSubmit} className="space-y-4">
//               {/* Email */}
//               <div>
//                 <label className="block text-xs font-medium text-slate-600 mb-1">
//                   Email
//                 </label>
//                 <input
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   type="email"
//                   required
//                   className="w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:ring-2 focus:ring-indigo-500"
//                   placeholder="admin@example.com"
//                 />
//               </div>

//               {/* Password */}
//               <div>
//                 <label className="block text-xs font-medium text-slate-600 mb-1">
//                   Password
//                 </label>
//                 <input
//                   type="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                   className="w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:ring-2 focus:ring-indigo-500"
//                   placeholder="••••••••"
//                 />

//                 {/* ✅ Links row */}
//                 <div className="mt-2 flex items-center justify-between text-xs">
//                   <Link
//                     to="/forgot-password"
//                     className="text-indigo-600 hover:text-indigo-700 font-medium"
//                   >
//                     Forgot password?
//                   </Link>

//                   <Link
//                     to="/register"
//                     className="text-slate-600 hover:text-slate-900 font-medium"
//                   >
//                     Create account
//                   </Link>
//                 </div>
//               </div>

//               {/* Error */}
//               {errorMessage && (
//                 <div className="text-xs font-semibold text-red-600 bg-red-50 border border-red-100 rounded-md px-3 py-2 animate-in fade-in duration-300">
//                   {errorMessage}
//                 </div>
//               )}

//               <button
//                 disabled={isLoading}
//                 type="submit"
//                 className="w-full py-2.5 text-sm font-medium bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-60 transition-colors"
//               >
//                 {isLoading ? "Signing In..." : "Sign In"}
//               </button>
//             </form>

//             {/* Optional extra helper */}
//             <div className="mt-4 text-center text-xs text-slate-500">
//               By signing in, you agree to your organization’s access policy.
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;
import React, { FormEvent, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { useLoginMutation } from "../api/authApi";
import { getDefaultRouteForUser } from "../utils/redirect";

const STORAGE_KEY = "logbook_auth_user_v2";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [login, { isLoading, error }] = useLoginMutation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);

  const from = (location.state as any)?.from?.pathname;

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLocalError(null);

    localStorage.removeItem("token");
    localStorage.removeItem(STORAGE_KEY);

    try {
      const res = await login({ email, password }).unwrap();
      if (!res?.token || !res?.user) {
        setLocalError(res?.message || "Invalid email or password");
        return;
      }
      navigate(from || getDefaultRouteForUser(), { replace: true });
    } catch (err: any) {
      setLocalError(
        err?.data?.message || err?.message || "Login failed. Try again."
      );
    }
  };

  const getErrorMessage = () => {
    if (localError) return localError;
    if (!error) return null;
    if ("status" in error) {
      if (error.status === "FETCH_ERROR")
        return "Network error: Cannot reach the server.";
      if (error.status === 401) return "Invalid email or password";
    }
    return "An unexpected error occurred";
  };

  const errorMessage = getErrorMessage();

  return (
    <div className="fixed inset-0 min-h-screen w-full flex overflow-hidden bg-[#0f172a] text-slate-200 selection:bg-indigo-500/30">
      {/* BACKGROUND DECORATION */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-indigo-500/10 blur-[120px] rounded-full" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-blue-500/10 blur-[120px] rounded-full" />

      {/* LEFT SIDE: BRANDING (Hidden on mobile) */}
      <div className="hidden lg:flex flex-1 flex-col items-center justify-center p-12 relative z-10 border-r border-white/5">
        <div className="max-w-md">
          {/* ✅ THE FIX: Added 'invert' class */}
          <img
            src="/niqs-logo.png"
            alt="NIQS Logo"
            className="h-20 w-auto mb-8 drop-shadow-2xl invert"
          />

          <h1 className="text-4xl font-bold tracking-tight text-white mb-4 leading-snug">
            The Nigerian Institute of Quantity Surveyors
          </h1>
          <p className="text-lg text-slate-400 leading-relaxed">
            Welcome to the official NIQS Membership Portal. Manage your
            professional records with ease.
          </p>
        </div>
      </div>

      {/* RIGHT SIDE: LOGIN FORM */}
      <div className="flex-1 flex items-center justify-center p-6 relative z-10">
        <div className="w-full max-w-[420px]">
          {/* Mobile Logo Only */}
          <div className="lg:hidden flex flex-col items-center mb-8">
            {/* ✅ THE FIX: Added 'invert' class here too */}
            <img
              src="/niqs-logo.png"
              alt="NIQS Logo"
              className="h-16 w-auto mb-4 invert"
            />

            <h2 className="text-xl font-bold text-white text-center">
              NIQS PORTAL
            </h2>
          </div>

          <div className="bg-white/5 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/10 p-8 md:p-10 transition-all hover:border-white/20">
            <div className="mb-8">
              <h2 className="text-2xl font-semibold text-white tracking-tight">
                Sign In
              </h2>
              <p className="text-sm text-slate-400 mt-2">
                Access your professional dashboard
              </p>
            </div>

            <form onSubmit={onSubmit} className="space-y-5">
              {/* Email */}
              <div>
                <label className="block text-xs font-medium text-slate-400 uppercase tracking-wider mb-2">
                  Email Address
                </label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  required
                  className="w-full bg-slate-900/50 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 transition-all"
                  placeholder="name@niqs.org"
                />
              </div>

              {/* Password */}
              <div>
                <label className="block text-xs font-medium text-slate-400 uppercase tracking-wider mb-2">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="w-full bg-slate-900/50 border border-white/10 rounded-xl px-4 py-3 pr-11 text-sm text-white placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 transition-all"
                    placeholder="••••••••"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((v) => !v)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-300 transition-colors"
                    tabIndex={-1}
                  >
                    {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>

              {/* Links */}
              <div className="flex items-center justify-between text-xs">
                <Link
                  to="/forgot-password"
                  title="Forgot Password"
                  className="text-indigo-400 hover:text-indigo-300 transition-colors"
                >
                  Forgot password?
                </Link>
                <Link
                  to="/register"
                  title="Create Account"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  New member? <span className="text-indigo-400">Register</span>
                </Link>
              </div>

              {/* Error Display */}
              {errorMessage && (
                <div className="text-xs font-medium text-red-400 bg-red-500/10 border border-red-500/20 rounded-xl px-4 py-3 animate-pulse">
                  {errorMessage}
                </div>
              )}

              <button
                disabled={isLoading}
                type="submit"
                className="w-full py-3.5 text-sm font-semibold bg-indigo-600 text-white rounded-xl hover:bg-indigo-500 active:scale-[0.98] disabled:opacity-50 disabled:active:scale-100 transition-all shadow-lg shadow-indigo-600/20"
              >
                {isLoading ? "Authenticating..." : "Sign In to Portal"}
              </button>
            </form>
          </div>

          <p className="text-center text-xs text-slate-500 mt-8">
            © {new Date().getFullYear()} Nigerian Institute of Quantity
            Surveyors. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
